import React from 'react'
import { Box } from '@mui/material'
import { useHistory, useParams } from 'react-router-dom'
import ConfigurationForm from './ConfigurationForm'

const ConfigurationPage = () => {
  const history = useHistory()
  const { configurationId } = useParams()

  const goBack = () => history.goBack()

  const pageTitle = configurationId
    ? 'Edit Badge Print Configuration'
    : 'Add Badge Print Configuration'

  return (
    <Box>
      <ConfigurationForm
        configurationId={configurationId || ''}
        title=""
        pageTitle={pageTitle}
        hideHeader
        onClose={goBack}
      />
    </Box>
  )
}

export default ConfigurationPage
